import { ContentType } from '../helper/enums'
import { TeaserEntry } from '../helper/interfaces'
import React from 'react'
import Link from 'next/link'
import { getLinkObjectFromTeaser } from '../helper/link'

interface Data {
  teasers: TeaserEntry[]
}

function TrendingTopics(data: Data) {
  const teasers = data.teasers

  return (
    <React.Fragment>
      { teasers.length > 0 && 
        <React.Fragment>
          <span className="ml-3">|</span>
          <div className="trending-topics-breadcrumbs">
            { teasers.map((teaser) => {
              const linkObject = getLinkObjectFromTeaser(teaser);
              return (
                <React.Fragment key={`trending-topics${teaser.id}`}>
                    { linkObject && linkObject.internalLink && (
                      <Link href={linkObject.internalLink} className="trending-topics-entry breadcrumb-item" aria-label={teaser.title}>
                        <span>{teaser.title}</span>
                      </Link>
                    )}
                    { linkObject && linkObject.externalLink && (
                      <Link href={linkObject.externalLink} className="trending-topics-entry" target="_blank" aria-label={teaser.title}>
                        <span>{teaser.topline}</span>
                        <span>{teaser.title}</span>
                      </Link>
                    )}
                </React.Fragment>
              )
            })
            }
        </div>
      </React.Fragment>
    }
    </React.Fragment>
  )
}

export default TrendingTopics